import Vue from 'vue'
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "page" */ '@/view/login/index'),
      meta: {
        isTab: false,
        isAuth: false
      }
    },
    {
      path: '/Index',
      name: 'Index',
      component: () => import(/* webpackChunkName: "page" */ '@/view/index/index'),
      meta: {
        // keepAlive: true
      },
      children: [
        {
          path: '/monitor',
          name: 'monitor',
          component: () => import(/* webpackChunkName: "page" */ '@/view/monitor/monitor'),
          meta: {
            // keepAlive: true,
          }
        },
        {
          path: '/eventPage',
          name: 'eventPage',
          component: () => import(/* webpackChunkName: "page" */ '@/view/monitor/eventPage'),
          meta: {
            // keepAlive: false,
          }
        }
      ]
    },
    {
      path: '/enlargePage',
      name: 'enlargePage',
      component: () => import(/* webpackChunkName: "page" */ '@/view/enlarge/index'),
      meta: {
        // keepAlive: false
      }
    }

  ],
  linkActiveClass: 'action'
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js